// Actions
export const CONVERSATION__GET_CONVERSATIONS = 'CONVERSATION__GET_CONVERSATIONS';
export const CONVERSATION__GET_CONVERSATION = 'CONVERSATION__GET_CONVERSATION';
export const CONVERSATION__START_CONVERSATION = 'CONVERSATION__START_CONVERSATION';
export const CONVERSATION__SEND_MESSAGE = 'CONVERSATION__SEND_MESSAGE';
export const CONVERSATION__REJECT_DAY_SWITCH = 'CONVERSATION__REJECT_DAY_SWITCH';
// Mutations
export const CONVERSATION__RESET = 'CONVERSATION__RESET';
export const CONVERSATION__MUTATE_LOADING_STATUS = 'CONVERSATION__MUTATE_LOADING_STATUS';
export const CONVERSATION__MUTATE_MESSAGES = 'CONVERSATION__MUTATE_MESSAGES';
export const CONVERSATION__MUTATE_CONVERSATIONS_BY_CONTRACTOR_ID =
  'CONVERSATION__MUTATE_CONVERSATIONS_BY_CONTRACTOR_ID';
export const CONVERSATION__MUTATE_APPEND_MESSAGE = 'CONVERSATION__MUTATE_APPEND_MESSAGE';
export const CONVERSATION__MUTATE_SET_CONVERSATIONS = 'CONVERSATION__MUTATE_SET_CONVERSATIONS';
export const CONVERSATION__MUTATE_SET_CONTACTS = 'CONVERSATION__MUTATE_SET_CONTACTS';
export const CONVERSATION__MUTATE_SET_CONVERSATION = 'CONVERSATION__MUTATE_SET_CONVERSATION';
// Getters
export const CONVERSATION__UNDUPED_CONTACTS = 'CONVERSATION__UNDUPED_CONTACTS';
